<template>
  <div>
    <v-toolbar
      flat
      dark color="highlight"
      v-bind:class="$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb'"
      dense
    >
      <v-toolbar-title>{{ blueprint != null ? blueprint.name: ''}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <!-- <v-card flat> -->
    <v-layout v-if="blueprint" wrap>
      <v-flex lg5 xs12>
        <v-container grid-list-md text-xs-center>
          <v-card>
            <v-container>
              <v-form v-model="valid">
                <can I="update" a="blueprints">
                  <v-text-field
                    outlined
                    dense
                    disabled
                    :rules="nameRules"
                    required
                    v-model="blueprint.name"
                    v-bind:label="$t('name')"
                  ></v-text-field>
                  <v-menu transition="scale-transition" origin="right top" offset-y
                    ref="menu1"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        dense
                        disabled
                        v-model="blueprint.deadline"
                        v-bind:label="$t('deadline')"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="blueprint.deadline" no-title></v-date-picker>
                  </v-menu>
                  <can I="update" a="blueprints">
                    <v-layout>
                      <v-select
                        outlined
                        dense
                        disabled
                        v-model="blueprint.installers"
                        :items="blueprint.allInstallers"
                        v-bind:label="$t('installer')"
                        chips
                        item-value="id"
                        item-text="fullName"
                        multiple
                        return-object
                      >
                        <!-- <template slot="selection" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                        </template>-->
                      </v-select>
                    </v-layout>
                  </can>
                  <v-textarea
                    outlined
                    disabled
                    v-model="blueprint.description"
                    v-bind:label="$t('description')"
                  ></v-textarea>
                </can>
              </v-form>
            </v-container>
          </v-card>
          <markers
            class="mb-6 mt-3"
            :blueprintFile="blueprint.blueprintFile"
            v-on:showMarkerDetails="showMarkerDetails"
            :markers="markers"
          ></markers>
        </v-container>
      </v-flex>
      <v-flex
        v-if="(blueprint.blueprintFile && !blueprint.blueprintFile.content) || !$store.state.isMobile"
        lg7
        xs12
      >
        <v-container :class="fullscreen ? 'sticky-blueprint': 'sticky-blueprint-fullscreen'">
          <zoomMarkup
            ref="markup"
            :readonly="true"
            v-on:fullscreen="toggleFullscreen"
            v-on:showMarkerDetails="showMarkerDetails"
            v-bind:blueprint="blueprint"
          ></zoomMarkup>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container v-else fill-height>
      <loading></loading>
    </v-container>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card flat color="primary" dark>
        <v-card-text>
          {{loadingText}}
          <!-- <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- </v-card> -->

    <div
      v-if="blueprint && blueprint.blueprintFile && blueprint.blueprintFile.content && $store.state.isMobile"
      outlined
      color="primary"
      class="floating-button"
    >
      <zoomMarkup
        ref="markup"
        :readonly="true"
        v-on:showMarkerDetails="showMarkerDetails"
        v-bind:blueprint="blueprint"
      ></zoomMarkup>
    </div>
    <savebeforeleave v-on:response="response" :dialog="saveDialog"></savebeforeleave>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

import markers from "@/components/pages/Markers/List";
import zoomMarkup from "@/components/pages/Markers/ZoomMarkup";
import jwtdecode from "jwt-decode";
import async from "async";
import scanQRCode from "@/components/pages/Markers/ScanQRCode";

import { serviceihub } from "@/services/service.ihub.js";

import { Promise } from "q";

const _serviceIhub = new serviceihub();

export default {
  name: "blueprintsDetails",
  components: {
    markers,
    zoomMarkup,
    scanQRCode
  },
  data() {
    return {
      blueprint: null,
      loadingText: "",
      hideMarkup: false,
      dialog: false,
      uploadForm: false,
      attributeTypes: null,
      leadThroughTypes: null,
      insulationTypes: null,
      menu: false,
      valid: false,
      nameRules: [v => !!v || `${this.$t("name")} ${this.$t("required")}`],
      markers: [],
      image: null,
      connection: navigator.onLine,
      saveDialog: false,
      to: null,
      fullscreen: false,
    };
  },
  computed: {
    markersui() {
      return this.$store.getters.markersui;
    },
    isOffline() {
      return this.$store.state.isOffline;
    }
  },
  methods: {
     toggleFullscreen(f) {
      this.fullscreen = !f;
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("archivedProjects"),
          to: { name: "ArchivedProjects" }
        },
        {
          name: this.blueprint.project,
          to: {
            name: "ArchivedProjectDetails",
            params: { id: this.blueprint.projectId }
          }
        },
        {
          name: this.blueprint.buildingComponent,
          to: {
            name: "ArchivedBuildingComponentDetails",
            params: { id: this.blueprint.buildingComponentId }
          }
        },
        {
          name: this.blueprint.name
        }
      ];
    },
    response(answer) {
      if (answer) {
        this.$refs.markup.$refs.markupFullscreen.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    showMarkerDetails(marker) {
     
        this.$router.push({
        name: "ArchivedMarkerDetails",
        params: {
          id: marker.id,
        }
      });
    },
  },
  async mounted() {
    let resBlueprint = await this.$http.getBlueprint(this.$route.params.id);
    this.blueprint = resBlueprint.data;
    this.makeBreadcrumb();

    //backbutton
    this.$store.state.previous = {
      name: "ArchivedBuildingComponentDetails",
      id: this.blueprint.buildingComponentId,
      breadcrumb: this.$t("buildingComponent")
    };
  },
  created() {},
  watch: {
    isOffline(n,o) {
      if(!n) this.dialog = false;
    },
    readonly(n, o) {},
    blueprint(n,o){}
  }
};
</script>


<style scoped>
.v-input--selection-controls {
  margin-top: 12px;
}
.v-messages .theme--light {
  height: 0px !important;
  min-height: unset !important;
}

</style>


// WEBPACK FOOTER //
// src/views/blueprints/archived/BlueprintsDetails.vue